export default __webpack_public_path__ + "static/media/bg.8db5464e.mp4";